import { RosterPilotLogo } from "../assets/RosterPilotLogo";

/**
 * The full-screen logo and spinner shown while the app cannot draw a page yet: Firebase is still
 * restoring the session, or a lazily loaded route's code is still downloading.
 */
export const AppLoading = () => (
  <div className="app-loading" role="status" aria-label="Loading RosterPilot" data-testid="app-loading">
    <div className="app-loading__logo">
      <RosterPilotLogo />
    </div>
    <div className="app-loading__spinner"></div>
  </div>
);
